import React, { useEffect } from 'react';

const NotFound: React.FC = () => {
  useEffect(() => {
    globalThis.location.href = 'https://placement.meilleurtaux.com/404';
  }, []);

  return null;
};

export default NotFound;
